// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterStyles } from "@eisinc/Overrides/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    gap: 10,
    css: css`
        padding-bottom: 15px;
    `,
};

filterStyles.heading = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

filterStyles.shipToGridItem = { width: [12, 6, 6, 3, 3] };

filterStyles.userGridItem = { width: [12, 6, 6, 3, 3] };

filterStyles.orderNumberGridItem = { width: [12, 6, 3, 3, 3] };

filterStyles.fromGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
        }
    `,
};

filterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-top: 10px;
    `,
};

filterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-top: 18px;
        `,
    },
};

filterStyles.orderTotalGridItem = { width: [12, 12, 6, 6, 6] };

filterStyles.orderTotalOperatorGridItem = { width: 6 };

filterStyles.orderTotalAmountGridItem = {
    width: 6,
    css: css`
        align-items: end;
    `,
};

filterStyles.orderTotalAmountTextField = {};

filterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            display: flex;
        `,
    },
};
